export default __webpack_public_path__ + "static/media/logo_title3_new.93b81b93.png";